<template>
  <chart-container :title="title">
    <div
      v-if="options.results.length > 0"
      :style="{
        'overflow-y': 'scroll',
        'max-height': `${computedHeigth}px`,
      }"
    >
      <v-row v-for="r in options.results" :key="r._id" no-gutters>
        <v-col cols="12" class="py-0">
          <result
            :id="r._id"
            :source="r._source"
            :hits="r.inner_hits"
            :elevation="6"
          />
        </v-col>
      </v-row>
    </div>
  </chart-container>
</template>

<script>
import ChartContainer from "@/components/dashboard/ChartContainer.vue";
import Result from "@/components/dashboard/data/Result.vue";
export default {
  components: {
    ChartContainer,
    Result,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  computed: {
    computedHeigth() {
      switch (this.height) {
        case 200:
          return 215;
        case 300:
          return 314.6;
        case 340:
          return 354;
        default:
          return this.height * 1.075;
      }
    },
  },
};
</script>

<style>
</style>